export const useIsEmbeddedSegment = () => {
  return false
}
